import { useReducer } from "react";
import { FAMILY_MEMBER_TEMPLATE } from "./ApplicationStateTemplate";

export function applicationReducer(state, action) {
    switch (action.type) {
        // GENERAL INFO ACTIONS
        case 'UPDATE_FIELD':
            return {
                ...state,
                [action.field]: action.value,
            };

        case 'UPDATE_BIRTHDAY':
            return {
                ...state,
                birthday: action.value,
                isMinor: action.isMinorValue,
            };

        // FAMILY INFO ACTIONS
        case 'ADD_FAMILY_MEMBER':
            return {
                ...state,
                familyInformation: [...state.familyInformation, FAMILY_MEMBER_TEMPLATE],
            };

        case 'REMOVE_FAMILY_MEMBER':
            return {
                ...state,
                familyInformation: state.familyInformation.filter((_, i) => i !== action.index),
            };

        case 'UPDATE_FAMILY_MEMBER':
            return {
                ...state,
                familyInformation: state.familyInformation.map((member, i) =>
                    i === action.index ? { ...member, [action.field]: action.value } : member
                ),
            };

        // SUBMISSION/META ACTIONS
        case 'SET_SUBMITTED':
            return {
                ...state,
                submitted: action.value,
                token: action.token || state.token,
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: action.value,
                errorMessage: action.message,
            };

        default:
            return state;
    }
}